import React, { useContext, useState } from "react";
import "../../styles/Widgets/WidgetsLibrary.css";
import ChartsDisplayImage from "./Charts/DisplayImage.png";
import CardsDisplayImage from "./Cards/DisplayImage.png";
import AnalogueGaugesDisplayImage from "./AnalogueGauges/DisplayImage.png";
import StatusIndicatorsDisplayImage from "./StatusIndicators/DisplayImage.png";
import LiquidLevelDisplayImage from "./LiquidLevel/DisplayImage.png";
import DigitalGaugesDisplayImage from "./DigitalGauges/DisplayImage.png";
import MapsDisplayImage from "./Maps/DisplayImage.png";
import ControlWidgetsDisplayImage from "./ControlWidgets/DisplayImage.png";
import TablesDisplayImage from "./Tables/DisplayImage.png";
import IndustrialWidgetsDisplayImage from "./IndustrialWidgets/DisplayImage.png";
import AlarmWidgetsDisplayImage from "./AlarmWidgets/DisplayImage.png";
import ButtonsDisplayImage from "./Buttons/DisplayImage.png";
import ChartsWidgets from "./Charts/ChartsWidgets";
import LiquidLevelWidgets from "./LiquidLevel/LiquidLevelWidgets";
import ButtonsWidgets from "./Buttons/ButtonsWidgets";
import { DashboardContext } from "../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
import AnalogueGaugesWidgets from "./AnalogueGauges/AnalogueGaugesWidgets";
const WidgetsLibrary = () =>{
    const {showWidgetsLibrary,setShowWidgetsLibrary} = useContext(DashboardContext);
    const[selectedWidgetBundle,setSelectedWidgetBundle] = useState('');
    if(!showWidgetsLibrary) return null;
    return(
        <div className="widgets-library-parent-container">
            <ChartsWidgets
                selectedWidgetBundle={selectedWidgetBundle}
                setSelectedWidgetBundle={setSelectedWidgetBundle}
            />
            <LiquidLevelWidgets
                selectedWidgetBundle={selectedWidgetBundle}
                setSelectedWidgetBundle={setSelectedWidgetBundle}
            />
            <ButtonsWidgets
                selectedWidgetBundle={selectedWidgetBundle}
                setSelectedWidgetBundle={setSelectedWidgetBundle}
            />
            <AnalogueGaugesWidgets
                selectedWidgetBundle={selectedWidgetBundle}
                setSelectedWidgetBundle={setSelectedWidgetBundle}
            />
            <div className="widgets-library-container"
                style={{display:selectedWidgetBundle === ''?'block':'none'}}>
                <div className="widgets-library-header-container">
                    <h3>Select widgets bundle</h3>
                    <p onClick={() => setShowWidgetsLibrary(false)}>&#10006;</p>
                </div>
                <div className="widgets-library-body-container">
                    <div className="widgets-library-grid">
                        <div className="widgets-bundle-container" onClick={() => setSelectedWidgetBundle('charts')}>
                            <h4>Charts</h4>
                            <img src={ChartsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Cards</h4>
                            <img src={CardsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container" onClick={() => setSelectedWidgetBundle('analogue_gauges')}>
                            <h4>Analogue gauges</h4>
                            <img src={AnalogueGaugesDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Status indicators</h4>
                            <img src={StatusIndicatorsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container" onClick={() => setSelectedWidgetBundle('liquid_level')}>
                            <h4>Liquid level</h4>
                            <img src={LiquidLevelDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Digital gauges</h4>
                            <img src={DigitalGaugesDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Maps</h4>
                            <img src={MapsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Control widgets</h4>
                            <img src={ControlWidgetsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Tables</h4>
                            <img src={TablesDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Industrial widgets</h4>
                            <img src={IndustrialWidgetsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container">
                            <h4>Alarm widgets</h4>
                            <img src={AlarmWidgetsDisplayImage} alt="Chart"/>
                        </div>
                        <div className="widgets-bundle-container" onClick={() => setSelectedWidgetBundle('buttons')}>
                            <h4>Buttons</h4>
                            <img src={ButtonsDisplayImage} alt="Chart"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WidgetsLibrary;